// import React, { useEffect, useMemo, useState } from "react";
// import api from "../../api";
// import {
//   Table,
//   Button,
//   Form,
//   Pagination,
//   InputGroup,
//   Modal,
//   Spinner,
//   Badge,
// } from "react-bootstrap";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Can from "../../components/Can";
// import "./Category.css";

// const initialForm = {
//   name: "",
//   description: "",
//   unit_id: "",
// };

// export default function Category() {
//   const [categories, setCategories] = useState([]);
//   const [units, setUnits] = useState([]);

//   const [search, setSearch] = useState("");
//   const [filterUnit, setFilterUnit] = useState("");

//   const [modalShow, setModalShow] = useState(false);
//   const [deleteModalShow, setDeleteModalShow] = useState(false);

//   const [form, setForm] = useState(initialForm);
//   const [editId, setEditId] = useState(null);
//   const [deleteId, setDeleteId] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [sortField, setSortField] = useState("id");
//   const [sortOrder, setSortOrder] = useState("asc");

//   useEffect(() => {
//     fetchAll();
//   }, []);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [search, filterUnit, rowsPerPage]);

//   const fetchAll = async () => {
//     try {
//       setLoading(true);

//       const [categoryRes, unitRes] = await Promise.all([
//         api.get(`/categories`),
//         api.get(`/units`),
//       ]);

//       setCategories(Array.isArray(categoryRes.data) ? categoryRes.data : []);
//       setUnits(Array.isArray(unitRes.data) ? unitRes.data : []);
//     } catch (error) {
//       console.error("Fetch Category Error:", error);
//       toast.error("Failed to fetch categories");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const unitMap = useMemo(() => {
//     return Object.fromEntries(units.map((unit) => [String(unit.id), unit.name]));
//   }, [units]);

//   const filteredCategories = useMemo(() => {
//     let data = [...categories];

//     if (search.trim()) {
//       const q = search.toLowerCase();

//       data = data.filter((cat) => {
//         const unitName = unitMap[String(cat.unit_id)] || "";

//         return [
//           cat.id,
//           cat.name,
//           cat.description,
//           cat.unit_id,
//           unitName,
//         ]
//           .map((value) => (value ?? "").toString().toLowerCase())
//           .join(" ")
//           .includes(q);
//       });
//     }

//     if (filterUnit) {
//       data = data.filter(
//         (cat) => String(cat.unit_id) === String(filterUnit)
//       );
//     }

//     data.sort((a, b) => {
//       let valueA = "";
//       let valueB = "";

//       if (sortField === "unit") {
//         valueA = unitMap[String(a.unit_id)] || "";
//         valueB = unitMap[String(b.unit_id)] || "";
//       } else {
//         valueA = a[sortField] ?? "";
//         valueB = b[sortField] ?? "";
//       }

//       valueA = valueA.toString().toLowerCase();
//       valueB = valueB.toString().toLowerCase();

//       if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
//       if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
//       return 0;
//     });

//     return data;
//   }, [categories, search, filterUnit, unitMap, sortField, sortOrder]);

//   const totalPages = Math.ceil(filteredCategories.length / rowsPerPage);
//   const indexOfLast = currentPage * rowsPerPage;
//   const indexOfFirst = indexOfLast - rowsPerPage;
//   const pageData = filteredCategories.slice(indexOfFirst, indexOfLast);

//   const handleChange = (field, value) => {
//     setForm((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const getSortIcon = (field) => {
//     if (sortField !== field) return "↕";
//     return sortOrder === "asc" ? "↑" : "↓";
//   };

//   const openAddModal = () => {
//     setForm(initialForm);
//     setEditId(null);
//     setModalShow(true);
//   };

//   const handleEdit = (cat) => {
//     setForm({
//       name: cat.name || "",
//       description: cat.description || "",
//       unit_id: cat.unit_id || "",
//     });

//     setEditId(cat.id);
//     setModalShow(true);
//   };

//   const closeModal = () => {
//     setModalShow(false);
//     setForm(initialForm);
//     setEditId(null);
//   };

//   const handleSave = async () => {
//     if (!form.name.trim() || !form.description.trim() || !form.unit_id) {
//       toast.error("All fields are required!");
//       return;
//     }

//     try {
//       setSaving(true);

//       const payload = {
//         name: form.name.trim(),
//         description: form.description.trim(),
//         unit_id: Number(form.unit_id),
//       };

//       if (editId) {
//         await api.put(`/categories/${editId}`, payload);
//         toast.success("Category updated successfully!");
//       } else {
//         await api.post(`/categories`, payload);
//         toast.success("Category added successfully!");
//       }

//       closeModal();
//       fetchAll();
//     } catch (error) {
//       console.error("Save Category Error:", error);
//       toast.error("Error saving category");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const openDeleteModal = (id) => {
//     setDeleteId(id);
//     setDeleteModalShow(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteId(null);
//     setDeleteModalShow(false);
//   };

//   const confirmDelete = async () => {
//     try {
//       await api.delete(`/categories/${deleteId}`);
//       toast.success("Category deleted successfully");
//       closeDeleteModal();
//       fetchAll();
//     } catch (error) {
//       console.error("Delete Category Error:", error);
//       toast.error("Failed to delete category");
//     }
//   };

//   const clearFilters = () => {
//     setSearch("");
//     setFilterUnit("");
//   };

//   const exportCSV = () => {
//     if (!filteredCategories.length) {
//       toast.warning("No data available to export");
//       return;
//     }

//     const headers = ["ID", "Name", "Description", "Unit"];
//     const rows = filteredCategories.map((cat) => [
//       cat.id,
//       cat.name,
//       cat.description,
//       unitMap[String(cat.unit_id)] || cat.unit_id || "",
//     ]);

//     const csvContent = [headers, ...rows]
//       .map((row) =>
//         row
//           .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
//           .join(",")
//       )
//       .join("\n");

//     const blob = new Blob([csvContent], {
//       type: "text/csv;charset=utf-8;",
//     });

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");

//     link.href = url;
//     link.download = "categories.csv";
//     link.click();

//     URL.revokeObjectURL(url);
//   };

//   return (
//     <div className="unit-page category-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>Category Management</h2>
//           <p>Manage categories with descriptions and unit-wise mapping.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchAll}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
//             <i className="fa-solid fa-file-export" aria-hidden="true"></i>
//             Export CSV
//           </Button>

//           <Can moduleKey="categories" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAddModal}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Category
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="category-stat-icon category-stat-icon-primary">
//             <i className="fa-solid fa-tags" aria-hidden="true"></i>
//           </div>
//           <div className="category-stat-text">
//             <span>Total Categories</span>
//             <strong>{categories.length}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="category-stat-icon category-stat-icon-accent">
//             <i className="fa-solid fa-filter" aria-hidden="true"></i>
//           </div>
//           <div className="category-stat-text">
//             <span>Filtered Result</span>
//             <strong>{filteredCategories.length}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="category-stat-icon category-stat-icon-success">
//             <i className="fa-solid fa-list-ol" aria-hidden="true"></i>
//           </div>
//           <div className="category-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-tags category-list-icon" aria-hidden="true"></i>
//               Category List
//             </h5>
//             <p>View, search, filter, add, update and delete categories.</p>
//           </div>

//           <div className="unit-toolbar-actions">
//             <InputGroup className="unit-search">
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>

//               <Form.Control
//                 placeholder="Search category, description, unit..."
//                 aria-label="Search category, description, unit"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />

//               {search && (
//                 <Button
//                   className="unit-clear-btn"
//                   onClick={() => setSearch("")}
//                   aria-label="Clear search"
//                 >
//                   Clear
//                 </Button>
//               )}
//             </InputGroup>

//             <Form.Select
//               className="unit-page-size category-unit-filter"
//               aria-label="Filter by unit"
//               value={filterUnit}
//               onChange={(e) => setFilterUnit(e.target.value)}
//             >
//               <option value="">All Units</option>
//               {units.map((unit) => (
//                 <option key={unit.id} value={unit.id}>
//                   {unit.name}
//                 </option>
//               ))}
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               aria-label="Rows per page"
//               value={rowsPerPage}
//               onChange={(e) => setRowsPerPage(Number(e.target.value))}
//             >
//               <option value={5}>5 rows</option>
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>

//             {(search || filterUnit) && (
//               <Button className="unit-btn unit-btn-light" onClick={clearFilters}>
//                 Reset
//               </Button>
//             )}
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading categories...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th
//                     className="sortable"
//                     onClick={() => handleSort("id")}
//                     style={{ width: "90px" }}
//                   >
//                     ID {getSortIcon("id")}
//                   </th>

//                   <th className="sortable" onClick={() => handleSort("name")}>
//                     Category {getSortIcon("name")}
//                   </th>

//                   <th>Description</th>

//                   <th className="sortable" onClick={() => handleSort("unit")}>
//                     Unit {getSortIcon("unit")}
//                   </th>

//                   <th className="text-end" style={{ width: "130px" }}>
//                     Actions
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {pageData.length > 0 ? (
//                   pageData.map((cat) => (
//                     <tr key={cat.id}>
//                       <td>
//                         <span className="unit-id">#{cat.id}</span>
//                       </td>

//                       <td>
//                         <div className="unit-name-box">
//                           <div className="unit-letter">
//                             {cat.name?.charAt(0)?.toUpperCase() || "C"}
//                           </div>

//                           <div>
//                             <strong>{cat.name}</strong>
//                             <small>Category ID: {cat.id}</small>
//                           </div>
//                         </div>
//                       </td>

//                       <td>{cat.description || "-"}</td>

//                       <td>
//                         <Badge className="unit-status">
//                           {unitMap[String(cat.unit_id)] || "-"}
//                         </Badge>
//                       </td>

//                       <td>
//                         <div className="unit-actions">
//                           <Can moduleKey="categories" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label={`Edit ${cat.name || "category"}`}
//                               onClick={() => handleEdit(cat)}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           <Can moduleKey="categories" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title="Delete"
//                               aria-label={`Delete ${cat.name || "category"}`}
//                               onClick={() => openDeleteModal(cat.id)}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="5">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-tags" aria-hidden="true"></i>
//                         </div>
//                         <h5>No categories found</h5>
//                         <p>Try another keyword or add a new category.</p>

//                         <Button
//                           className="unit-btn unit-btn-primary"
//                           onClick={openAddModal}
//                         >
//                           <i className="fa-solid fa-plus" aria-hidden="true"></i>
//                           Add Category
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing{" "}
//             <strong>
//               {filteredCategories.length === 0 ? 0 : indexOfFirst + 1}
//             </strong>{" "}
//             to{" "}
//             <strong>
//               {Math.min(indexOfLast, filteredCategories.length)}
//             </strong>{" "}
//             of <strong>{filteredCategories.length}</strong> entries
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage((prev) => prev - 1)}
//               />

//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item
//                   key={i + 1}
//                   active={i + 1 === currentPage}
//                   onClick={() => setCurrentPage(i + 1)}
//                 >
//                   {i + 1}
//                 </Pagination.Item>
//               ))}

//               <Pagination.Next
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage((prev) => prev + 1)}
//               />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={modalShow}
//         onHide={closeModal}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {editId ? "Edit Category" : "Add New Category"}
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Form.Group className="mb-3">
//             <Form.Label>Category Name</Form.Label>
//             <Form.Control
//               placeholder="Enter category name"
//               value={form.name}
//               onChange={(e) => handleChange("name", e.target.value)}
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Description</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               placeholder="Enter description"
//               value={form.description}
//               onChange={(e) => handleChange("description", e.target.value)}
//             />
//           </Form.Group>

//           <Form.Group>
//             <Form.Label>Unit</Form.Label>
//             <Form.Select
//               value={form.unit_id}
//               onChange={(e) => handleChange("unit_id", e.target.value)}
//             >
//               <option value="">-- Select Unit --</option>
//               {units.map((unit) => (
//                 <option key={unit.id} value={unit.id}>
//                   {unit.name}
//                 </option>
//               ))}
//             </Form.Select>
//           </Form.Group>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeModal}>
//             Cancel
//           </Button>

//           <Button
//             className="unit-btn unit-btn-primary"
//             onClick={handleSave}
//             disabled={saving}
//           >
//             {saving ? "Saving..." : editId ? "Update Category" : "Create Category"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={deleteModalShow}
//         onHide={closeDeleteModal}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Category</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <p className="unit-delete-text">
//             Are you sure you want to delete this category? This action cannot be
//             undone.
//           </p>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
//             Cancel
//           </Button>

//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }





import React, { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import api from "../../api";
import {
  Table,
  Button,
  Form,
  Pagination,
  InputGroup,
  Modal,
  Spinner,
  Badge,
} from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import Can from "../../components/Can";
import "./Category.css";

const initialForm = {
  name: "",
  description: "",
  unit_id: "",
  user_ids: [],
};

// "technician" -> "Technician", "data-analyst" -> "Data Analyst".
const roleLabelFor = (roleName) =>
  (roleName || "")
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

// Single-line, compact option label (matches the existing dropdown style)
// shared by both the option list and the selected-value chips, e.g.
// "Sagar Varma — Technician — #23 — sagar.varma@jaipuria.edu.in". Also
// doubles as the text react-select's default search matches against, so
// name/role/id/email are all searchable.
const assigneeOptionLabel = (user) => {
  const name = user.name || user.username || `User #${user.id}`;
  const roleLabel = roleLabelFor(user.role_name);
  return [name, roleLabel, `#${user.id}`, user.email].filter(Boolean).join(" — ");
};

export default function Category() {
  const [categories, setCategories] = useState([]);
  const [units, setUnits] = useState([]);
  const [technicians, setTechnicians] = useState([]);

  const [search, setSearch] = useState("");
  const [filterUnit, setFilterUnit] = useState("");

  const [modalShow, setModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    fetchAll();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, filterUnit, rowsPerPage]);

  const fetchAll = async () => {
    try {
      setLoading(true);

      const [categoryRes, unitRes, technicianRes] = await Promise.all([
        api.get(`/categories`),
        api.get(`/units`),
        // Category assignment eligibility spans Technician, Developer and
        // Data Analyst (opt-in ?roles= on the existing endpoint -- see
        // userController.getTechnicianUsers -- so every OTHER caller of
        // this same endpoint, e.g. TechnicianPerformancePanel.jsx and
        // SubCategory.js's technician-only staff_ids picker, is unaffected).
        api.get(`/technician-users?roles=technician,developer,data-analyst`),
      ]);

      setCategories(Array.isArray(categoryRes.data) ? categoryRes.data : []);
      setUnits(Array.isArray(unitRes.data) ? unitRes.data : []);
      setTechnicians(Array.isArray(technicianRes.data) ? technicianRes.data : []);
    } catch (error) {
      console.error("Fetch Category Error:", error);
      toast.error("Failed to fetch categories");
    } finally {
      setLoading(false);
    }
  };

  const unitMap = useMemo(() => {
    return Object.fromEntries(units.map((unit) => [String(unit.id), unit.name]));
  }, [units]);

  const filteredCategories = useMemo(() => {
    let data = [...categories];

    if (search.trim()) {
      const q = search.toLowerCase();

      data = data.filter((cat) => {
        const unitName = unitMap[String(cat.unit_id)] || "";

        return [
          cat.id,
          cat.name,
          cat.description,
          cat.unit_id,
          unitName,
        ]
          .map((value) => (value ?? "").toString().toLowerCase())
          .join(" ")
          .includes(q);
      });
    }

    if (filterUnit) {
      data = data.filter(
        (cat) => String(cat.unit_id) === String(filterUnit)
      );
    }

    data.sort((a, b) => {
      let valueA = "";
      let valueB = "";

      if (sortField === "unit") {
        valueA = unitMap[String(a.unit_id)] || "";
        valueB = unitMap[String(b.unit_id)] || "";
      } else {
        valueA = a[sortField] ?? "";
        valueB = b[sortField] ?? "";
      }

      valueA = valueA.toString().toLowerCase();
      valueB = valueB.toString().toLowerCase();

      if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
      if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

    return data;
  }, [categories, search, filterUnit, unitMap, sortField, sortOrder]);

  const totalPages = Math.ceil(filteredCategories.length / rowsPerPage);
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const pageData = filteredCategories.slice(indexOfFirst, indexOfLast);

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return "↕";
    return sortOrder === "asc" ? "↑" : "↓";
  };

  const openAddModal = () => {
    setForm(initialForm);
    setEditId(null);
    setModalShow(true);
  };

  const handleEdit = (cat) => {
    setForm({
      name: cat.name || "",
      description: cat.description || "",
      unit_id: cat.unit_id || "",
      user_ids: Array.isArray(cat.assignedUsers)
        ? cat.assignedUsers.map((u) => String(u.id))
        : [],
    });

    setEditId(cat.id);
    setModalShow(true);
  };

  const closeModal = () => {
    setModalShow(false);
    setForm(initialForm);
    setEditId(null);
  };

  const handleSave = async () => {
    if (!form.name.trim() || !form.description.trim() || !form.unit_id) {
      toast.error("All fields are required!");
      return;
    }

    try {
      setSaving(true);

      const payload = {
        name: form.name.trim(),
        description: form.description.trim(),
        unit_id: Number(form.unit_id),
        user_ids: form.user_ids.map(Number),
      };

      if (editId) {
        await api.put(`/categories/${editId}`, payload);
        toast.success("Category updated successfully!");
      } else {
        await api.post(`/categories`, payload);
        toast.success("Category added successfully!");
      }

      closeModal();
      fetchAll();
    } catch (error) {
      console.error("Save Category Error:", error);
      toast.error("Error saving category");
    } finally {
      setSaving(false);
    }
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setDeleteModalShow(true);
  };

  const closeDeleteModal = () => {
    setDeleteId(null);
    setDeleteModalShow(false);
  };

  const confirmDelete = async () => {
    try {
      await api.delete(`/categories/${deleteId}`);
      toast.success("Category deleted successfully");
      closeDeleteModal();
      fetchAll();
    } catch (error) {
      console.error("Delete Category Error:", error);
      // 409 CATEGORY_IN_USE: tickets still use it -- show why.
      const data = error?.response?.data || {};
      toast.error(data.message || data.error || "Failed to delete category");
    }
  };

  const clearFilters = () => {
    setSearch("");
    setFilterUnit("");
  };

  const exportCSV = () => {
    if (!filteredCategories.length) {
      toast.warning("No data available to export");
      return;
    }

    const headers = ["ID", "Name", "Description", "Unit", "Assigned To"];
    const rows = filteredCategories.map((cat) => [
      cat.id,
      cat.name,
      cat.description,
      unitMap[String(cat.unit_id)] || cat.unit_id || "",
      Array.isArray(cat.assignedUsers) && cat.assignedUsers.length
        ? cat.assignedUsers.map((u) => `${u.name} (#${u.id})`).join("; ")
        : "Unassigned",
    ]);

    const csvContent = [headers, ...rows]
      .map((row) =>
        row
          .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
          .join(",")
      )
      .join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "categories.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <div className="unit-page category-mgmt-theme">

      <div className="category-heading-box">
        <div className="category-heading-content">
          <div className="category-heading-icon">
            <i className="fa-solid fa-tags" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>Category Management</h2>
            <p>Manage categories with descriptions and unit-wise mapping.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchAll}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
            <i className="fa-solid fa-file-export" aria-hidden="true"></i>
            Export CSV
          </Button>

          <Can moduleKey="categories" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={openAddModal}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Category
            </Button>
          </Can>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card category-stat-blue">
          <div className="category-stat-content">
            <div className="category-stat-text">
              <span>Total Categories</span>
              <strong>{categories.length}</strong>
            </div>
            <div className="category-stat-icon">
              <i className="fa-solid fa-tags" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card category-stat-purple">
          <div className="category-stat-content">
            <div className="category-stat-text">
              <span>Filtered Result</span>
              <strong>{filteredCategories.length}</strong>
            </div>
            <div className="category-stat-icon">
              <i className="fa-solid fa-filter" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card category-stat-green">
          <div className="category-stat-content">
            <div className="category-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>
            <div className="category-stat-icon">
              <i className="fa-solid fa-list-ol" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar">
          <div className="category-section-title">
            <div className="category-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div>
              <h5>Category List</h5>
              <p>View, search, filter, add, update and delete categories.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions">
            <InputGroup className="unit-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>

              <Form.Control
                placeholder="Search category, description, unit..."
                aria-label="Search category, description, unit"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => setSearch("")}
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <Form.Select
              className="unit-page-size category-unit-filter"
              aria-label="Filter by unit"
              value={filterUnit}
              onChange={(e) => setFilterUnit(e.target.value)}
            >
              <option value="">All Units</option>
              {units.map((unit) => (
                <option key={unit.id} value={unit.id}>
                  {unit.name}
                </option>
              ))}
            </Form.Select>

            <Form.Select
              className="unit-page-size"
              aria-label="Rows per page"
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>

            {(search || filterUnit) && (
              <Button className="unit-btn unit-btn-light" onClick={clearFilters}>
                <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
                Reset
              </Button>
            )}
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading categories...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th
                    className="sortable"
                    onClick={() => handleSort("id")}
                    style={{ width: "90px" }}
                  >
                    ID {getSortIcon("id")}
                  </th>

                  <th className="sortable" onClick={() => handleSort("name")}>
                    Category {getSortIcon("name")}
                  </th>

                  <th>Description</th>

                  <th className="sortable" onClick={() => handleSort("unit")}>
                    Unit {getSortIcon("unit")}
                  </th>

                  <th style={{ width: "220px" }}>Assigned To</th>

                  <th className="text-end" style={{ width: "130px" }}>
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {pageData.length > 0 ? (
                  pageData.map((cat) => (
                    <tr key={cat.id}>
                      <td>
                        <span className="unit-id">#{cat.id}</span>
                      </td>

                      <td>
                        <div className="unit-name-box">
                          <div className="unit-letter">
                            {cat.name?.charAt(0)?.toUpperCase() || "C"}
                          </div>

                          <div>
                            <strong>{cat.name}</strong>
                            <small>Category ID: {cat.id}</small>
                          </div>
                        </div>
                      </td>

                      <td>{cat.description || "-"}</td>

                      <td>
                        <Badge className="unit-status category-unit-badge">
                          <i className="fa-solid fa-building me-1" aria-hidden="true"></i>
                          {unitMap[String(cat.unit_id)] || "-"}
                        </Badge>
                      </td>

                      <td>
                        {Array.isArray(cat.assignedUsers) && cat.assignedUsers.length > 0 ? (
                          <div className="category-assignee-chips">
                            {cat.assignedUsers.map((u) => (
                              <Badge
                                key={u.id}
                                className="unit-status category-assignee-badge"
                                title={u.email ? `${u.name} — ${u.email}` : u.name}
                              >
                                <i className="fa-solid fa-user me-1" aria-hidden="true"></i>
                                {u.name} <span className="category-assignee-id">#{u.id}</span>
                              </Badge>
                            ))}
                          </div>
                        ) : (
                          <Badge className="unit-status category-assignee-empty">
                            Unassigned
                          </Badge>
                        )}
                      </td>

                      <td>
                        <div className="unit-actions">
                          <Can moduleKey="categories" actionKey="edit">
                            <Button
                              className="unit-icon-btn unit-edit"
                              title="Edit"
                              aria-label={`Edit ${cat.name || "category"}`}
                              onClick={() => handleEdit(cat)}
                            >
                              <i className="fa-solid fa-pen" aria-hidden="true"></i>
                            </Button>
                          </Can>

                          <Can moduleKey="categories" actionKey="delete">
                            <Button
                              className="unit-icon-btn unit-delete"
                              title="Delete"
                              aria-label={`Delete ${cat.name || "category"}`}
                              onClick={() => openDeleteModal(cat.id)}
                            >
                              <i className="fa-solid fa-trash" aria-hidden="true"></i>
                            </Button>
                          </Can>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-tags" aria-hidden="true"></i>
                        </div>
                        <h5>No categories found</h5>
                        <p>Try another keyword or add a new category.</p>

                        <Button
                          className="unit-btn unit-btn-primary"
                          onClick={openAddModal}
                        >
                          <i className="fa-solid fa-plus" aria-hidden="true"></i>
                          Add Category
                        </Button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing{" "}
            <strong>
              {filteredCategories.length === 0 ? 0 : indexOfFirst + 1}
            </strong>{" "}
            to{" "}
            <strong>
              {Math.min(indexOfLast, filteredCategories.length)}
            </strong>{" "}
            of <strong>{filteredCategories.length}</strong> entries
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
              />

              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item
                  key={i + 1}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}

              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
              />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={modalShow}
        onHide={closeModal}
        centered
        className="unit-modal"
        dialogClassName="admin-teal-modal"
        backdropClassName="admin-teal-backdrop"
      >
        <Modal.Header closeButton>
          <div className="category-modal-heading">
            <div className="category-modal-icon">
              <i
                className={editId ? "fa-solid fa-pen-to-square" : "fa-solid fa-tags"}
                aria-hidden="true"
              ></i>
            </div>
            <div>
              <small>Category Setup</small>
              <Modal.Title>
                {editId ? "Edit Category" : "Add New Category"}
              </Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Category Name</Form.Label>
            <Form.Control
              placeholder="Enter category name"
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter description"
              value={form.description}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Unit</Form.Label>
            <Form.Select
              value={form.unit_id}
              onChange={(e) => handleChange("unit_id", e.target.value)}
            >
              <option value="">-- Select Unit --</option>
              {units.map((unit) => (
                <option key={unit.id} value={unit.id}>
                  {unit.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label>Assigned User / Technician</Form.Label>
            <Select
              isMulti
              className="category-react-select"
              classNamePrefix="category-select"
              placeholder="Select technician, developer or data analyst..."
              options={technicians.map((tech) => ({
                value: String(tech.id),
                label: assigneeOptionLabel(tech),
              }))}
              value={technicians
                .filter((tech) => form.user_ids.includes(String(tech.id)))
                .map((tech) => ({
                  value: String(tech.id),
                  label: assigneeOptionLabel(tech),
                }))}
              onChange={(selectedOptions) => {
                const selectedIds = (selectedOptions || []).map((option) => option.value);
                handleChange("user_ids", selectedIds);
              }}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Category" : "Create Category"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={deleteModalShow}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger"
        backdropClassName="admin-teal-backdrop"
      >
        <Modal.Header closeButton>
          <div className="category-modal-heading">
            <div className="category-modal-icon category-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>
            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete Category</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <p className="unit-delete-text">
            Are you sure you want to delete this category? This action cannot be
            undone.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}